import React from "react";
import { Dialog, DialogContent, Button, IconButton } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CloseIcon from "@mui/icons-material/Close";
import "../../style/popup.css";

const Popup = ({ open, onClose, onKeepShopping, onGoToCart }) => {
  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      className="popup-dialog"
      BackdropProps={{
        className: "popup-backdrop"
      }}
    >
      {/* Modern Header with Icon */}
      <div className="popup-header">
        <IconButton 
          className="popup-close-btn"
          onClick={onClose}
          size="small"
        >
          <CloseIcon />
        </IconButton>
        
        <div className="popup-icon">
          <CheckCircleIcon 
            className="popup-success-icon" 
            sx={{ fontSize: 64 }} 
          />
        </div>
        <h2 className="popup-title">Item Added!</h2>
        <p className="popup-subtitle">What would you like to do next?</p>
      </div>

      {/* Content with Action Buttons */}
      <DialogContent className="popup-content">
        <div className="popup-actions">
          <Button 
            onClick={onGoToCart} 
            variant='contained'
            className="popup-btn popup-btn-primary"
          >
            Go to Cart
          </Button>
          <Button 
            onClick={onKeepShopping} 
            variant='contained'
            className="popup-btn popup-btn-secondary"
          >
            Continue Shopping
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default Popup;
